import {
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  Link,
} from '@mui/material';
import { Col } from 'shared/ui/Col';

export const PackagePromotionContent = () => {
  return (
    <Col spacing={7} sx={{ maxHeight: '80vh', overflowY: 'auto' }}>
      <Typography variant="headerM">Пакетное продвижение</Typography>

      {/* Бронзовый пакет */}
      <Col spacing={2}>
        <Typography variant="accentM">🥉 Бронзовый пакет</Typography>
        <Typography>Цель: Минимальный, но эффективный охват.</Typography>

        <List dense sx={{ pl: 2 }}>
          <ListItem disablePadding>
            <ListItemText primary="• Баннер на сайте — срок: 1 день." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="• Telegram — 1 сторис (показы 24 часа)." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="• Пуш-уведомления — 1 пуш в приложении (охват до 3500 пользователей)." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="• Новость от объекта (помощь в составлении текста)." />
          </ListItem>
        </List>

        <Typography>
          <strong>Стоимость:</strong> 5 000 ₽
        </Typography>
      </Col>

      {/* Серебряный пакет */}
      <Col spacing={2}>
        <Typography variant="accentM">🥈 Серебряный пакет</Typography>
        <Typography>Цель: Комплексное продвижение с аналитикой.</Typography>

        <List dense sx={{ pl: 2 }}>
          <ListItem disablePadding>
            <ListItemText primary="• Баннер на сайте — срок: 2 дня." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="• Telegram — 1 пост в канале (охват до 300 подписчиков)." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="• 1 сторис в ТГ (показы 24 часа)." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="• Пуш-уведомления — 2 пуша в приложении (охват до 3500 пользователей)." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="• 2 Новости от объекта (помощь в составлении текста)." />
          </ListItem>
        </List>

        <Typography>
          <strong>Стоимость:</strong> 10 000 ₽
        </Typography>
      </Col>

      {/* Золотой пакет */}
      <Col spacing={2}>
        <Typography variant="accentM">🥇 Золотой пакет</Typography>
        <Typography>Цель: Максимальное внимание и персонализация.</Typography>

        <List dense sx={{ pl: 2 }}>
          <ListItem disablePadding>
            <ListItemText primary="• Баннер на сайте — срок: 3 дня." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="• Telegram — 2 поста в канале (охват до 300 подписчиков)." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="• 3 сторис в ТГ (анимация + теги)." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="• Пуш-уведомления — 3 пуша в приложении (охват до 3500 пользователей)." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="• 3 Новости от объекта (помощь в составлении текста)." />
          </ListItem>
        </List>

        <Typography>
          <strong>Стоимость:</strong> 15 000 ₽
        </Typography>
      </Col>

      <Divider sx={{ my: 3 }} />

      {/* Как подключить */}
      <Typography variant="headerXS">Как подключить?</Typography>
      <Typography>1. Свяжитесь с одним из менеджеров Nedvex:</Typography>

      <List dense sx={{ pl: 2 }}>
        <ListItem disablePadding>
          <ListItemText
            primary={
              <>
                • Олег – WA:{' '}
                <Link
                  href="https://wa.me/375295322767"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +375295322767
                </Link>
                , TG:{' '}
                <Link
                  href="https://t.me/yakuta_oleg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @yakuta_oleg
                </Link>
              </>
            }
          />
        </ListItem>
        <ListItem disablePadding>
          <ListItemText
            primary={
              <>
                • Контент отдел – моб/WA:{' '}
                <Link
                  href="https://wa.me/79683000112"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +7 968 300-01-12
                </Link>
                , TG:{' '}
                <Link
                  href="https://t.me/Nedvex_content_manager"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @Nedvex_content_manager
                </Link>
              </>
            }
          />
        </ListItem>
      </List>

      <Typography>2. Выберите пакет.</Typography>
      <Typography>3. Отправьте материалы (фото, описание).</Typography>
      <Typography>
        4. Оплатите счёт — запустим продвижение в течение 2 дней.
      </Typography>
    </Col>
  );
};
